// UI component
import ProgressBar from './ProgressBar';

export default ProgressBar;
